/**
 * 运行环境检测工具
 * 通过 User-Agent 判断当前是否在企业微信或微信中打开
 */

/**
 * 获取 User-Agent
 * @returns {String}
 */
function getUserAgent() {
  return navigator.userAgent || ''
}

/**
 * 是否在企业微信中
 * @returns {Boolean}
 */
export function isWxWork() {
  return /wxwork/i.test(getUserAgent())
}

/**
 * 是否在微信中（非企业微信）
 * @returns {Boolean}
 */
export function isWeixin() {
  const ua = getUserAgent()
  return /MicroMessenger/i.test(ua) && !/wxwork/i.test(ua)
}

/**
 * 是否在微信环境（包括企业微信和普通微信）
 * @returns {Boolean}
 */
export function isAnyWx() {
  return /MicroMessenger/i.test(getUserAgent())
}
